// extracted by mini-css-extract-plugin
export var circle = "_2w-2";
export var icon = "_2w-a";
export var iconHighlight = "_2w-0";
export var lg = "_2w-8";
export var md = "_2w-7";
export var outline = "_2w-4";
export var sm = "_2w-6";
export var square = "_2w-1";
export var xl = "_2w-9";
export var xs = "_2w-5";
export var xxs = "_2w-3";